import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import DbModelHandler from "../components/DbModelHandler";
import Products from "../ui-components/pages/Products";
import CountryContext from "../CountryContext";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import Tabs from "../ui-components/Tabs";
import explorerTables from "../utils/explorerTables";

const getTableIndexByName = (name) => {
  const index = explorerTables.findIndex((t) => t.path === name);
  if (index < 0) {
    return 0;
  }
  return index;
};

const Explorer = () => {
  const { tableName } = useParams();
  const { country } = useContext(CountryContext);
  const [data, setData] = useState(null);
  const apiRequest = useCountryAxiosInstance();
  const intl = useIntl();

  const { push } = useHistory();
  const [tabIndex, setTabIndex] = useState(() =>
    getTableIndexByName(tableName)
  );

  const table = explorerTables[tabIndex];

  useEffect(() => {
    setTabIndex(getTableIndexByName(tableName));
  }, [tableName]);

  useEffect(() => {
    let cancel = false;
    const fetchData = async () => {
      try {
        const data = await apiRequest.get(`/${table.path}/all`, {
          params: table.params ?? {},
        });
        if (!cancel) {
          setData(data);
        }
      } catch (error) {
        push({
          title: intl.formatMessage({ id: "server_error" }),
          type: "error",
        });
      }
    };

    if (table && table.path !== "products") {
      fetchData();
    }

    return () => {
      cancel = true;
    };
    // eslint-disable-next-line
  }, [table]);

  return (
    <div className="flex flex-col w-full my-8">
      <Tabs
        setActiveTab={(index) => {
          const table = explorerTables[index];
          setData(null);
          push(`/${country.code}/explorer/${table.path}`);
        }}
        active={tabIndex}
        tabs={explorerTables}
      />
      {table.path === "products" ? 
      (
        <Products/>
      ) : data ?
      (
        <DbModelHandler table={table} data={data} setData={setData} />
      ) : null}
    </div>
  );
};

export default Explorer;
